// extracted by mini-css-extract-plugin
export default {"buttonsBlock":"m4U5Pufk1QVxIF0qm9hO","button":"M7X5565oBZrivZrFPYA5","error":"TTcgfN0zEa2umkod4d6W","text":"ZZL06kkQ5YuDnbLodZqB"};